/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type PaymentMethodCardsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type PaymentMethodCardsQuery = {
  readonly __typename?: 'Query';
  readonly paymentMethodCards: ReadonlyArray<
    | {
        readonly __typename: 'PaymentMethodBillingAccount';
        readonly id: string;
        readonly description: string | null;
        readonly nickname: string | null;
        readonly isDefault: boolean;
        readonly cardType: Types.CardType;
        readonly expirationState: Types.CardExpirationState;
      }
    | {
        readonly __typename: 'PaymentMethodCard';
        readonly id: string;
        readonly description: string | null;
        readonly nickname: string | null;
        readonly isDefault: boolean;
        readonly cardType: Types.CardType;
        readonly expirationState: Types.CardExpirationState;
      }
  >;
};

export const paymentMethodCardsQueryMock: ExecutionResult<PaymentMethodCardsQuery> =
  {
    data: {
      paymentMethodCards: [
        {
          __typename: 'PaymentMethodBillingAccount',
          id: '509e6ea9-fee4-42a9-9625-87ce71904308',
          description: 'Hello World',
          nickname: 'Hello World',
          isDefault: true,
          cardType: 'AMERICAN_EXPRESS',
          expirationState: 'EXPIRED',
        },
        {
          __typename: 'PaymentMethodBillingAccount',
          id: 'a7a7163b-a7ed-4a96-a8a1-85e3da00a9a4',
          description: 'Hello World',
          nickname: 'Hello World',
          isDefault: false,
          cardType: 'AMERICAN_EXPRESS',
          expirationState: 'EXPIRED',
        },
        {
          __typename: 'PaymentMethodBillingAccount',
          id: '534319d0-8060-4b59-aa25-0f9c4016b1bd',
          description: 'Hello World',
          nickname: 'Hello World',
          isDefault: false,
          cardType: 'AMERICAN_EXPRESS',
          expirationState: 'EXPIRED',
        },
      ],
    },
  };

export const PaymentMethodCardsDocument = gql`
  query paymentMethodCards {
    paymentMethodCards {
      ... on PaymentMethodBillingAccount {
        __typename
        id
        description
        nickname
        isDefault
        cardType
        expirationState
      }
      ... on PaymentMethodCard {
        __typename
        id
        description
        nickname
        isDefault
        cardType
        expirationState
      }
    }
  }
`;

export function usePaymentMethodCardsQuery(
  options?: Omit<Urql.UseQueryArgs<PaymentMethodCardsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    PaymentMethodCardsQuery,
    PaymentMethodCardsQueryVariables
  >({ query: PaymentMethodCardsDocument, ...options });
}
